import moment from "moment";
import axios from "axios";

export function formatNumberWithDots(number) {
  return (number || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

export function calculateTimeDifference(startTime, endTime) {
  const start = new Date(startTime);
  const end = new Date(endTime);

  // Tính sự khác biệt thời gian (milliseconds)
  const diffMs = end.getTime() - start.getTime();

  // Chuyển đổi sự khác biệt thời gian từ milliseconds thành phút và giờ
  const diffMins = Math.floor(diffMs / 1000 / 60);
  const hours = Math.floor(diffMins / 60);
  const minutes = diffMins % 60;

  // Tạo chuỗi kết quả
  return `${hours}g ${minutes}p`;
}

export function convertMinutesToHoursAndMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}g ${remainingMinutes}p`;
}

export const formatString = (str) => {
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/\s/g, "");
  return str;
};

export const getDescriptionPlace = (address_components) => {
  const newArr = address_components.map((item) => item.long_name);
  return newArr.join(", ");
};

export const getPlaceDetailFromLatLng = async (lat, lng) => {
  const apiKey = process.env.REACT_APP_GOOGNG_API_KEY; // Thay bằng key thật
  const url = `https://rsapi.goong.io/Geocode?latlng=${lat},${lng}&api_key=${apiKey}`;

  try {
    const response = await axios.get(url);
    if (response.data.results && response.data.results.length > 0) {
      const place = response.data.results[0];
      const regionName = formatString(place.compound.province || "");
      const placeDetail = {
        regionName,
        placeName: place.name,
        description: place?.formatted_address || "",
        lat: place.geometry.location.lat,
        lng: place.geometry.location.lng,
        place_id: place.place_id,
      };
      return placeDetail;
    } else {
      console.warn("Không tìm thấy địa điểm.");
      return null;
    }
  } catch (error) {
    console.error("Lỗi khi gọi API Goong:", error);
    return null;
  }
};

export const getPlaceDetailFromPlaceId = async (placeId) => {
  try {
    const response = await axios.get(`https://rsapi.goong.io/Place/Detail`, {
      params: {
        place_id: placeId,
        api_key: process.env.REACT_APP_GOOGNG_API_KEY,
      },
    });
    const place = response.data.result;
    const regionName = formatString(place.compound.province || "");
    if (place) {
      const placeDetail = {
        regionName,
        placeName: place.name,
        description: place.formatted_address,
        lat: place.geometry.location.lat,
        lng: place.geometry.location.lng,
        place_id: place.place_id,
      };
      return placeDetail;
    } else {
      throw new Error("Không tìm thấy địa điểm");
    }
  } catch (error) {
    console.error("Lỗi khi gọi API Goong:", error);
    throw error;
  }
};

export const callPhoneNumber = (phoneNumber) => {
  const normalized = phoneNumber.replace(/\s+/g, "");
  window.open(`tel:${normalized}`, "_self");
};
